import { EBuyPackageStatus } from '../../../../types';
import { SuccessScreensContainer } from '../SuccessScreens';
import { PaymentErrorContainer } from '../PaymentError';
import * as styles from '../../BuyResultModal.css';
import { UIHeading2 } from '@cian/ui-kit';
import { NotEnoughMoneyContainer } from '../NotEnoughMoney';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectBuyPackageModalStatus } from '../../../../selectors/buyPackageModal';
import { Loader } from '../Loader';

export const BuyResultModalContent = () => {
  const status = useSelector(selectBuyPackageModalStatus);

  switch (status) {
    case EBuyPackageStatus.Ok:
    case EBuyPackageStatus.OkWithDeposit:
      return <SuccessScreensContainer />;

    case EBuyPackageStatus.Error:
      return <PaymentErrorContainer />;

    case EBuyPackageStatus.TariffNotAvailable:
      return (
        <div className={styles['not_available_screen']}>
          <UIHeading2>Услуга недоступна</UIHeading2>
        </div>
      );

    case EBuyPackageStatus.NotEnoughMoney:
      return <NotEnoughMoneyContainer />;

    case EBuyPackageStatus.Loading: {
      return <Loader />;
    }

    default: {
      return null;
    }
  }
};
